
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacidade",
      function () {
        return require("private-next-pages/privacidade.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacidade"])
      });
    }
  